module.exports = __webpack_public_path__ + "static/under_construction-ea822c04dc3a677653a7e12141893243.png";